import { render, staticRenderFns } from "./ProductUnitList.vue?vue&type=template&id=0d752462&"
import script from "./ProductUnitList.vue?vue&type=script&lang=js&"
export * from "./ProductUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports